// libs
import { useDispatch } from 'react-redux'
import { useLazyQuery } from '@apollo/client/react'
// graphql
import { RISK_TEMPLATE_QUERY, RISK_VIEWS_QUERY } from 'graphql/risk/queries'
// types
import { IRiskTemplate, IRiskView } from 'types/graphql'
// redux
import { setRiskViews as setRiskViewsAction, setRiskViewsLoading } from 'store/reducers/riskViews'
import { setRiskTemplates as setRiskTemplatesAction, setRiskTemplatesLoading } from 'store/reducers/riskTemplates'
// utils
import get from 'lodash/get'
import { parseGraphQLErrorMessages } from '../utils'

export const useRiskModuleData = () => {
  const dispatch = useDispatch()

  const [getRiskViews] = useLazyQuery(RISK_VIEWS_QUERY)
  const [getRiskTemplates] = useLazyQuery(RISK_TEMPLATE_QUERY)

  const setRiskViews = async () => {
    try {
      dispatch(setRiskViewsLoading(true))

      const data = await getRiskViews({
        variables: { pagination: { pageTake: 1000, pageSkip: 0 }, filter: { isLinkedView: false } }
      })

      const riskViews = get(data, 'data.riskViews.data', []) as IRiskView[]

      dispatch(setRiskViewsAction(riskViews))
    } catch (e) {
      console.log('[useSetRiskTemplates.setRiskViews]: ', parseGraphQLErrorMessages(e))
    } finally {
      dispatch(setRiskViewsLoading(false))
    }
  }

  const setRiskTemplates = async () => {
    try {
      dispatch(setRiskTemplatesLoading(true))

      const data = await getRiskTemplates({
        variables: { pagination: { pageTake: 1000, pageSkip: 0 } }
      })

      const riskTemplates = get(data, 'data.riskTemplates.data', []) as IRiskTemplate[]

      dispatch(setRiskTemplatesAction(riskTemplates))
    } catch (e) {
      console.log('[useSetRiskTemplates.setRiskTemplates]: ', parseGraphQLErrorMessages(e))
    } finally {
      dispatch(setRiskTemplatesLoading(false))
    }
  }

  return {
    setRiskViews,
    setRiskTemplates
  }
}
